import axios from 'axios';
import PaisEditar from '../types/PaisEditar';

async function InsertarPais(PaisNuevo: PaisEditar) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/insertar_pais"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "pais": [
                {
                    "nombre": PaisNuevo.pais,
                    "codigo_iso": PaisNuevo.codigo_iso,
                    "codigo_tel": PaisNuevo.codigo_tel,
                    "habilitado": PaisNuevo.habilitado
                }
            ]
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default InsertarPais;